import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/kredity" as const,
	[Locale.en]: "/credits" as const,
} satisfies LocalizedString;

export function getCreditListingPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
